import { FETCH_ERROR } from "@boark/shared/consts/fetch-error";
import { useQuery } from "@tanstack/react-query";

import { getProcurement, getProcurements } from "../services/procurement";

export function useGetProcurements() {
  return useQuery({
    queryKey: ["procurements"],
    queryFn: () => getProcurements(),
    staleTime: 1000 * 60,
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetProcurement(id: string) {
  return useQuery({
    queryKey: ["procurement", id],
    queryFn: () => getProcurement(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
